export default __webpack_public_path__ + "static/RaTtAco-da4ee392f70dcec9056c4a12bfe037c9.pdf";